import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

import './DevicesStatusChart.scss';

interface DevicesStatusChartProps {
  mctCount: number;
  mctActive: number;
  sbsCount: number;
  sbsActive: number;
  srstCount: number;
  srstActive: number;
  smstCount: number;
  smstActive: number;
  isFullInfo?: boolean;
  isFirstInfo?: boolean;
}

const DevicesStatusChart: React.FC<DevicesStatusChartProps> = ({
  mctCount,
  mctActive,
  sbsCount,
  sbsActive,
  srstCount,
  srstActive,
  smstCount,
  smstActive,
  isFullInfo = false,
  isFirstInfo = false,
}) => {
  const categories: string[] = [];
  const onlineData: number[] = [];
  const offlineData: number[] = [];

  const showFirstGroup = isFullInfo || isFirstInfo;
  const showSecondGroup = isFullInfo || !isFirstInfo;

  if (mctCount > 0 && showFirstGroup) {
    categories.push('MCT');
    onlineData.push(mctActive);
    offlineData.push(mctCount - mctActive);
  }

  if (sbsCount > 0 && showFirstGroup) {
    categories.push('SRBM');
    onlineData.push(sbsActive);
    offlineData.push(sbsCount - sbsActive);
  }

  if (srstCount > 0 && showSecondGroup) {
    categories.push('SRST');
    onlineData.push(srstActive);
    offlineData.push(srstCount - srstActive);
  }

  if (smstCount > 0 && showSecondGroup) {
    categories.push('SMST');
    onlineData.push(smstActive);
    offlineData.push(smstCount - smstActive);
  }

  if (categories.length === 0) {
    return null;
  }

  const rowHeight = 30;
  const calculatedHeight = categories.length * rowHeight + 20;
  const options: ApexOptions = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: { show: false },
      sparkline: { enabled: false },
      parentHeightOffset: 0,
    },

    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '70%',
        columnWidth: '100%',
        borderRadius: 4,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 5,
            style: { fontSize: '11px', fontWeight: 700 },
            formatter: function (val: string) {
              return val;
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    colors: ['#94C748', '#E0E0E0'],
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return val > 2 ? val.toString() : '';
      },
      style: {
        fontSize: '12px',
      },
    },
    grid: {
      show: true,
      padding: { left: 5, right: 0, top: -20, bottom: 0 },
    },
    xaxis: {
      categories: categories,
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px',
        },
      },
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      cssClass: 'devices-tooltip',
    },
    legend: {
      show: false,
    },
  };

  const series = [
    {
      name: 'Online',
      data: onlineData,
    },
    {
      name: 'Offline',
      data: offlineData,
    },
  ];
  return (
    <div style={{ width: '170px', minHeight: `${calculatedHeight}px` }}>
      <ReactApexChart options={options} series={series} type="bar" height={calculatedHeight} />
    </div>
  );
};

export default DevicesStatusChart;
